import { mapActions } from 'vuex'
import { mapState } from 'vuex'
import { useToast } from 'primevue/usetoast'

import './scss/style.scss'

export default {
   name: 'DesconsiderarAtividade',

   data() {
      return {
         toast: useToast(),
         active: false,
         atvDialog: false,
         dataAtividade: null,
         data_ordem: null,
         horaAtividade: null,
         atividade_tipo: null,
         locomotiva: null,
         patioOrigem: null,
         patioDestino: null,
         patioFormato: null,
         observacao: null,
         form: {
            pagina: null,
            limite: null,
            escalaId: this.$route.params.id
         },
         confirmacoes: [],
         codigoMensagem: null,
         solicitarConfirmacao: null,
         mensagemConfirmacao: null,
         atividadeTipoAtivos: null,
         abrirAlerta: false,
         mensagemAlerta: null,
         configuracao: null,
         payload: null
      }
   },

   props: {
      matricula: null,
      escalaId: null,
      data_fixa: false,
      data_escala: null,
      label: null,
      icon: null,
      id: null
   },
   emits: ['eventoAtividade'],
   computed: {
      ...mapState('gestaoPerido', ['atividadeTipo', 'patio', 'atividadePorId'])
   },

   methods: {
      ...mapActions('gestaoPerido', ['ActionObterAtividadesDetalhes', 'ActionObterAtividadePorId', 'ActionDesconsiderarAtividade']),
      abrirDialogAlerta() {
         this.abrirAlerta = true
      },

      async abrirDialog() {
         this.active = true
         if (this.id) {
            await this.ActionObterAtividadePorId(this.id)

            if (this.atividadePorId) {
               this.configuracao = JSON.parse(localStorage.getItem('configuracoes'))
               this.atvDialog = true
            }
         }
         this.active = false
      },

      //Forçar restart
      async desconsiderarAtividade() {
         try {
            this.active = true

            const resposta = await this.ActionDesconsiderarAtividade({
               id: this.id,
               observacao: this.observacao
            });
               
            this.configuracao = JSON.parse(localStorage.getItem('configuracoes'))
            let mensagemSucesso = this.configuracao.habilitarSolicitacaoRegistroPonto ? 'Solicitação realizada com sucesso!' : 'Registro desconsiderado com sucesso!'

            this.$toast.add({
               severity: 'success',
               summary: 'Salvo!',
               detail: mensagemSucesso,
               life: 3000
            });

            console.log('XGH: Desconsiderar', resposta)
                                 
            this.$emit('eventoAtividade')

            await this.ActionObterAtividadesDetalhes(this.form)

            this.atvDialog = false
            this.active = false
         } catch (error) {
            this.active = false
            const { mensagens } = error.response.data
            this.showError(mensagens[0].descricao)
         }
      },

      showError(erro) {
         this.toast.add({
            severity: 'error',
            summary: 'Falha',
            detail: erro,
            life: 4000
         })
      }
   }
}
